export class TrifectaRequestAbortedError extends Error {
  constructor() {
    super('aborted');
    this.name = 'TrifectaRequestAbortedError';
  }
}
